
<div class="main-wrapper">

  <div class="login-bg">
      <div class="left-sec">
          <img class="main-logo" src="assets/images/logo.png" alt="">
          <h5>login</h5> 
              <div class="form-input">
                  <label for="email" class="label label-1">User Name</label>
                  <input type="text" id="txt_loginuname" [(ngModel)]="entity.Username">
              </div>
              <div class="form-input">
                  <label for="password" class="label label-2">Password</label>
                  <input type="password"id="txt_loginpswd" [(ngModel)]="entity.Password" (keyup.enter)="login()">
              </div>
              <div>
                  <button class="btn-1" id="btn_loginsave" (click)="login()">Sign in</button>
              </div> 
          <div class="cr-fo"> 
              <a class="cr-1" href="#" (click)="Click()">Create Account</a>
              <a class="cr-2" href="#" (click)="linkClick()">Forgot Password ?</a> 
          </div>
      </div>
      <div class="right-sec">
          <div class="header-txt">
              <h3>OFFICE AUTOMATION TOOL</h3>
              <p>To increase cost savings and become more sustainable by reducing paper, printing, document binding, and courier costs</p>
              <span>VERSION 1.0.0</span>
          </div>
      </div>
  </div>
</div>
 
<kendo-dialog title="Forgot Password" *ngIf="forgotPassword" (close)="closeForgotPassword()"  
  [width]="700">
  <app-forgotpwd (closeForgotPassword)="closeForgotPassword()"> </app-forgotpwd>
</kendo-dialog>

<kendo-dialog title="Create Account" *ngIf="CreateAccount" (close)="close()" [height]="400" [width]="1000">
  <app-add-user (closeAddUser)="closeAddUser()"> </app-add-user>
</kendo-dialog>
  